import React, { useRef } from "react";
import "./FeatureCards.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Autoplay } from "swiper/modules";
import { ArrowLeft, ArrowRight } from "lucide-react";

type CardType = {
  label: string;
  title: string;
  subtitle: string;
  desc: string;
  image: string;
  color: string;
};

const CARDS: CardType[] = [
  {
    label: "Business Solution",
    title: "ERP Management System",
    subtitle: "All-in-one business operations platform",
    desc: "A smart solution to manage billing, inventory, and employee data efficiently while improving productivity.",
    image: "/erp1.jpg",
    color: "#00cfff",
  },
  {
    label: "Finance & Trading",
    title: "Trading Assistant",
    subtitle: "Smart trading support system",
    desc: "Analyze trading data, track performance, and make better decisions with intelligent insights.",
    image: "/trade1.jpg",
    color: "#7c3aed",
  },
  {
    label: "Construction",
    title: "Construction System",
    subtitle: "Efficient project management",
    desc: "Track progress, handle resources, and improve overall project efficiency seamlessly.",
    image: "/cons.jpg",
    color: "#f59e0b",
  },
  {
    label: "AI & Automation",
    title: "AI Assistant",
    subtitle: "Smart automation & intelligence",
    desc: "Automate tasks, provide insights, and enhance productivity using advanced AI technologies.",
    image: "/a1.webp",
    color: "#10b981",
  },
  {
    label: "E-Commerce",
    title: "E-Commerce Platform",
    subtitle: "Seamless online shopping",
    desc: "Build and manage online stores with product listings, secure payments, and order management.",
    image: "/e-commerce1.jpg",
    color: "#ef4444",
  },
  {
    label: "Education",
    title: "School Application",
    subtitle: "Smart platform for institutions",
    desc: "Manage students, classes, attendance, and online learning efficiently in one place.",
    image: "/courses.webp",
    color: "#3b82f6",
  },
];

const FeatureCards: React.FC = () => {
  const swiperRef = useRef<any>(null);

  return (
    <section className="fcards-section">
      <div className="container">
        <div className="fcards-header">
          <span className="section-label">What We Build</span>
          <h2 className="section-title">Our Solutions Explore our thinking</h2>
          <p className="section-subtitle">
            Cutting-edge products built for the modern world
          </p>
        </div>

        <div className="swiper-wrapper-custom">
          <Swiper
            onSwiper={(swiper) => (swiperRef.current = swiper)}
            modules={[Autoplay]}
            spaceBetween={20}
            slidesPerView={1.1}
            centeredSlides={true}
            loop={true}
            autoplay={{ delay: 3000, disableOnInteraction: false }}
            breakpoints={{
              480: { slidesPerView: 1.3, spaceBetween: 20 },
              700: { slidesPerView: 2.1, spaceBetween: 24 },
              1024: { slidesPerView: 2.8, spaceBetween: 28 },
              1280: { slidesPerView: 3.2, spaceBetween: 28 },
            }}
          >
            {CARDS.map((card, i) => (
              <SwiperSlide key={i}>
                {({ isActive }) => (
                  <div
                    className={`fcard ${isActive ? "fcard--active" : ""}`}
                    style={
                      { "--card-color": card.color } as React.CSSProperties
                    }
                  >
                    <div
                      className="fcard__bg"
                      style={{ backgroundImage: `url(${card.image})` }}
                    />
                    <div className="fcard__gradient" />
                    <div className="fcard__glow" />

                    <div className="fcard__content">
                      <span className="fcard__label">{card.label}</span>
                      <h3 className="fcard__title">{card.title}</h3>
                      <p className="fcard__subtitle">{card.subtitle}</p>
                      <p className="fcard__desc">{card.desc}</p>
                      <div className="fcard__cta">
                        <span>Explore</span>
                        <ArrowRight size={13} />
                      </div>
                    </div>
                  </div>
                )}
              </SwiperSlide>
            ))}
          </Swiper>

          <button
            className="swiper-nav swiper-nav--prev"
            onClick={() => swiperRef.current?.slidePrev()}
          >
            <ArrowLeft size={18} />
          </button>
          <button
            className="swiper-nav swiper-nav--next"
            onClick={() => swiperRef.current?.slideNext()}
          >
            <ArrowRight size={18} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default FeatureCards;